export function missingComponentField(componentName, fieldName, preview) {
  const message = `The ${componentName} item is missing a ${fieldName}! Please make sure this is set in Directus or Velocity.`;
  if (!preview) throw new Error(message);
  console.warn(message);
}
